module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c("div")
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fe9a49ea","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./sample/components/core/footer.vue
// module id = 687
// module chunks = 2